/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Confirm_DeleteInputs */

const vi_warehouse_position_confirm_delete = /** @type {(inputs: Warehouse_Position_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận ngừng dùng vị trí này?`)
};

/**

* @param {Warehouse_Position_Confirm_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_confirm_delete = /** @type {((inputs?: Warehouse_Position_Confirm_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Confirm_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_confirm_delete(inputs)
});